import { useEffect, useRef } from "react";
import './style.css';
import PropTypes from "prop-types";

const ApplePayButton = ({ onClick, disabled }) => {
     const applePayButtonRef = useRef(null);

  useEffect(() => {
    const button = applePayButtonRef.current;
    if (!button) return;

    const handleClick = (event) => {
      event.preventDefault();
      if (!disabled) {
        onClick(event);
      }
    };

    button.addEventListener("click", handleClick);

    // clear event for unmount
    return () => {
      button.removeEventListener("click", handleClick);
    };
  }, [disabled, onClick]);
  
    return (
        <div className={`apple-pay-button-wrapper ${disabled ? "disabled" : ""}`}>
            <apple-pay-button
                ref={applePayButtonRef}
                buttonstyle="black"
                type="plain"
                locale="en-US"
            />
        </div>
    );
};

ApplePayButton.propTypes = {
    onClick: PropTypes.func.isRequired, // ✅ warns in console if not passed
    disabled: PropTypes.bool,
};

export default ApplePayButton;